import { useDispatch } from "react-redux";

import { Button } from "@mui/material";

import { Tooltip } from "components/Tooltip";

import { i18n } from "services/i18nService";
import {
  addToReorderList,
  generatePos,
} from "services/sosInventoryService/sosApi";
import { handleProgramError } from "services/utility/errors";

import { openAlert } from "globalState/alertSlice";
import {
  loadingIndicatorOn,
  loadingIndicatorOff,
} from "globalState/loadingSlice";

export function ReorderReportActions(props) {
  const { checkedIds, settings } = props;
  const dispatch = useDispatch();

  async function handleAddToReorderList() {
    dispatch(loadingIndicatorOn());
    const { success, message } = await addToReorderList(checkedIds);
    if (success) {
      const message = i18n("alert.SuccessAddedToReorderList");
      dispatch(openAlert({ type: "success", message }));
      dispatch(loadingIndicatorOff());
    } else {
      dispatch(loadingIndicatorOff());
      const errorMessage = message || i18n("alert.ErrorNotAddedToReorderList");
      handleProgramError(new Error(errorMessage));
    }
  }

  async function handleGeneratePos() {
    dispatch(loadingIndicatorOn());
    const params = {
      items: checkedIds,
      locationId: settings.locations[0]?.id,
      includePOs: settings.includePOs,
      includeRMAs: settings.includeRMAs,
      includeWOs: settings.includeWOs,
      includeRentals: settings.includeRentals,
      includeNulls: settings.includeNulls,
    };
    const { success, message } = await generatePos(params);
    if (success) {
      const message = i18n("alert.SuccessGeneratePos");
      dispatch(openAlert({ type: "success", message }));
      dispatch(loadingIndicatorOff());
    } else {
      dispatch(loadingIndicatorOff());
      const errorMessage = message || i18n("alert.ErrorGeneratingPos");
      handleProgramError(new Error(errorMessage));
    }
  }

  const disabled = !checkedIds.length;

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <Tooltip title={disabled ? i18n("tooltip.GeneratePurchaseOrders") : ""}>
        <div>
          <Button
            sx={{ lineHeight: "1" }}
            disabled={disabled}
            onClick={handleGeneratePos}
          >
            {i18n("reports.GeneratePOs")}
          </Button>
        </div>
      </Tooltip>
      <Tooltip title={disabled ? i18n("tooltip.AddToReorderList") : ""}>
        <div>
          <Button
            sx={{ lineHeight: "1" }}
            disabled={disabled}
            onClick={handleAddToReorderList}
          >
            {i18n("reports.AddToReorderList")}
          </Button>
        </div>
      </Tooltip>
    </div>
  );
}
